import { useTranslation } from "react-i18next";
import { Box, Button, Text, TextLink } from "@hawkins/components";
import { Dimensions, Typography } from "@hawkins/variables";
import { IconArrowRight } from "@hawkins/assets";

import { TranslationNamespace } from "../../types";
import { useContentfulTranslation } from "../../hooks/useContentfulTranslation";
import { prepareContentfulHtml } from '@lep-shared/richTextHtml';
import { Page } from "../Page";
import { getPortalUrl } from "../../utils";
import { LoadingOverlay } from "../LoadingOverlay";


export default function Home() {
  const { t } = useTranslation(TranslationNamespace.LEP);
  const { getContentfulEntry, isReady } = useContentfulTranslation();

  if (!isReady) {
    return <LoadingOverlay />;
  }

  const contentfulData = getContentfulEntry("7z2jnzYR0yfw8XpGGrG4pc");
  if (!contentfulData) {
    console.error("Contentful data not found for home page");
    return (
      <Page columns={1}>
        <Text>{t('error_msg_2')}</Text>
      </Page>
    );
  }

  return (
    <Page columns={2}>
      <Box>
        <div style={{ fontSize: Typography.FontSize16 }}
          dangerouslySetInnerHTML={{
            __html: prepareContentfulHtml(contentfulData.body),
          }}
        ></div>
        <Text bold level={2}>
          {t("new_user")}
        </Text>
        <Text gutterBottom={Dimensions.Space16} level={2}>
          {t('please_create_account')}
        </Text>
        <TextLink href="/register">
          <Button icon={IconArrowRight} data-testid="create-account-button">
            {t("create_an_account")}
          </Button>
        </TextLink>

        <Text gutterTop={Dimensions.Space16} level={2}>
          {t('returning_user')}{' '}
          <TextLink
            onClick={() => { window.location.href = getPortalUrl(); }}
            style={{ fontSize: Typography.FontSize16 }}
            variant="standalone"
          >
            {t('sign_in')}
          </TextLink>
        </Text>

        <Text gutterTop={Dimensions.Space16} level={2}>
          {t('questions')}{' '}
          <TextLink
            href="/faq"
            style={{ fontSize: Typography.FontSize16 }}
            variant="standalone"
          >
            {t('read_faq')}
          </TextLink>
          {' | '}
          <TextLink
            href="mailto:leportalsupport@legal.netflix.com"
            style={{ fontSize: Typography.FontSize16 }}
            variant="standalone"
          >
            {t('contact_us')}
          </TextLink>
        </Text>
      </Box>
    </Page>
  );
}
